import customLocalStorage from 'Jsx/Utils/customLocalStorage';
import { payloadType } from './types';

export const eventNames = {
  ADD_TO_CART: 'AddToCart',
  ADD_TO_CUSTOM_BUNDLE: 'AddToCustomBundle',
  ADD_BUNDLE_TO_CART: 'AddBundleToCart',
  ADD_TO_WISH_LIST: 'AddToWishlist',
  GO_TO_CHECKOUT: 'GoToCheckout',
  GO_TO_CHECKOUT_POPUP: 'GoToCheckoutPopUp',
  DOWNLOAD_TRACK_SYLLABUS: 'DownloadTrackSyllabus',
};

export const eventSources = {
  GIFT_CARD_MODAL: 'GiftCardModal',
  WHIST_LIST: 'Wishlist',
  BUNDLE_DETAIL: 'BundleDetail',
  COURSE_DETAIL: 'CourseDetail',
  CUSTOM_BUNDLE: 'CustomBundle',
  SHOPPING_CART: 'ShoppingCart',
  OFF_BOARDING: 'OffBoarding',
  COURSE_CARD: 'CourseCard',
  COURSE_CARD_PREVIEW: 'CourseCardPreview',
  MEMBERSHIP: 'Membership',
  SHOPPING_CART_POPUP: 'ShoppingCartPopup',
  SHOPPING_CART_MAIN_MENU: 'ShoppingCartMainMenu',
  COURSE_DETAIL_POP_UP_VIEW: 'COURSE_DETAIL_POP_UP_VIEW',
  CUSTOM_BUNDLE_POP_UP_VIEW: 'CUSTOM_BUNDLE_POP_UP_VIEW',
  LANDING_COURSE_POP_UP_VIEW: 'LANDING_COURSE_POP_UP_VIEW',
  CHECKOUT_VIEW: 'CHECKOUT_VIEW',
  SHOPPING_CART_VIEW: 'SHOPPING_CART_VIEW',
  MEMBERSHIP_VIEW: 'MEMBERSHIP_VIEW',
  COURSE_DETAIL_VIEW: 'COURSE_DETAIL_VIEW',
  BUNDLE_DETAIL_VIEW: 'BUNDLE_DETAIL_VIEW',
  MEMBERSHIP_LANDING_POP_UP_VIEW: 'MEMBERSHIP_LANDING_POP_UP_VIEW',
  BLACK_FRIDAY_SHOPPINGCART_NOTIFICATION: 'BlackFridayShoppingCartNotification',
  TRACK_DETAIL: 'TrackDetail',
};

const STORE_FB_EVENTS = 'storeFBEvents';

export const facebookTracking = (eventName: string, payload: payloadType) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, payload);
  }
};

export const setFbEventToLocalStorage = ({
  eventName,
  fbTrackPayload,
  sourcePage,
}: {
  eventName: string;
  fbTrackPayload: payloadType;
  sourcePage?: string;
}) => {
  const otherFbEventsStringify = customLocalStorage.getItem(STORE_FB_EVENTS);
  const newEvents = otherFbEventsStringify
    ? JSON.parse(otherFbEventsStringify)
    : [];

  newEvents.push({
    sourcePage,
    eventName,
    fbTrackPayload,
  });
  customLocalStorage.setItem(STORE_FB_EVENTS, JSON.stringify(newEvents));
};

export const recollectAndSendFBTracks = () => {
  const fbEventsStringify = customLocalStorage.getItem(STORE_FB_EVENTS);
  const fbEvents = fbEventsStringify ? JSON.parse(fbEventsStringify) : [];

  if (fbEvents.length > 0) {
    fbEvents.forEach(event => {
      const eventName = event?.eventName;
      const sourcePage = event?.sourcePage;
      const fbTrackPayload = event?.fbTrackPayload || {};
      let fbTrackName = '';

      if (eventName && sourcePage) {
        fbTrackName = `${eventName}-${sourcePage} `;
      } else if (eventName) {
        fbTrackName = eventName;
      }
      if (fbTrackName && Object.values(fbTrackPayload).length > 0) {
        facebookTracking(fbTrackName, fbTrackPayload);
        customLocalStorage.removeItem(STORE_FB_EVENTS);
      }
    });
  }
};
